// src/api.js
import axios from 'axios';

// ① Base URL now includes the `/api` prefix
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/api'
});

// ② Automatically inject auth token on every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');
  //console.log('[API] token from localStorage:', token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  //console.log('[API] Final headers:', config.headers);
  return config;
}, error => Promise.reject(error));


export default api;
